<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Reports</h2>
      </div>
      <div class="container-fluid">
        <el-tabs v-model="activeTab">
          <can I="create" a="installation">
            <el-tab-pane label="Report Config" name="report_config">
              <ReportConfig></ReportConfig>
            </el-tab-pane>
          </can>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ReportConfig from "../report/config";
import { mapGetters, mapActions } from "vuex";
// import { ZOHOTHTTP } from "../../../store/actions";
import axios from "axios";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Tag
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  data() {
    return {
      selectedPaymentModel: [],
      packageConfigs: [],
      paymentModel: `OS`,
      orderVat: 5,
      orderDiscount: 0,
      
      form: {
        endpoint: "",
        field: "",
        operation: "",
        inputValue: "",
        dynamicTags: [],
        inputVisible: false
      },
      formResults: [],
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: "report_config",
      showOffCanvas: false
    };
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-tag": Tag,
    ReportConfig
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  // watch: {
  //   paymentModel: function(newVal, oldVal) {
  //     this.selectedPaymentModel = this.packageConfigs.find(
  //       x => x.Package == newVal
  //     );
  //     this.regDataParams.deviceRequest.paymentModel = newVal;
  //   }
  // },
  methods: {
    handleClose(tag) {
      this.form.dynamicTags.splice(this.form.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.form.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.form.inputValue;
      if (inputValue) {
        this.form.dynamicTags.push(inputValue);
      }
      this.form.inputVisible = false;
      this.form.inputValue = "";
    },

    onSubmit() {
      let inputResults = this.form;
      if (inputResults) {
        this.formResults.push(inputResults);
      }

      console.log(this.formResults);

      // this.form.endpoint = ""
      // this.form.inputValue = ""
      // this.form.dynamicTags = []
      // this.form.operation = ""
      // this.form.field = ""
    }
  },

  async mounted() {}
};
</script>

<style lang="scss" scoped>
.container-fluid .page-content {
  padding: 0px !important;
}

.container-fluid .container-fluid {
  padding: 0px !important;
}
.el-form-item__label {
  text-align: left !important;
}
.el-select-dropdown__item {
  line-height: 20px;
  display: flex;
  flex-flow: column;

  span {
    line-height: 20px !important;
  }
}
.price-display {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/reports.vue